module.exports = "<!-- <ngx-loading\n  [show]=\"spinnerService.showSpinner\"\n  [config]=\"{\n    fullScreenBackdrop: true,\n    backdropBackgroundColour: '$gray-lighter',\n    primaryColour: '#000000',\n    secondaryColour: '#565656',\n    tertiaryColour: '#a0a0a0'\n  }\"\n>\n</ngx-loading> -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/neenu.korula/AA/eventorg-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main